import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Field, reduxForm, change as changeFieldValue, formValueSelector} from 'redux-form';
import DatePicker, {registerLocale, setDefaultLocale} from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import Moment from 'react-moment';
import InputMask from 'react-input-mask';

import {
    renderFieldMonetarioLabelEncima,
    renderTextArea,
    required,
    requiredSelect,
} from '../../util/inputs';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import {
    PERFIL_ADMIN,
    getAdminEmpresa,
    getGestorEmpresa,
    getFinanceiroEmpresa,
    getOperadorEmpresa, getFinanceiroCaixa,
} from '../../security/securityContext';

import {
    cadastrarCentroCusto,
    atualizarCentroCusto,
    excluirCentroCusto,
    buscarTiposOcorrenciaCentroCusto,
    buscarCentroCusto, selecionaCentroCusto,
} from '../../actions/centro-custo/index';
import exportarCentroCustoParaCSV from './exportarCentroCusto';
import PainelFiltrosCentroCusto from './PainelFiltrosCentroCusto';
import CentroCusto from './CentroCusto';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import ModalExcluirCentroCusto from './ModalExcluirCentroCusto';
import {showSuccessMsg} from '../../util/messagesUtil';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoCentroCusto from './PaginacaoCentroCusto';
import BotoesPaginacaoCentroCusto from './BotoesPaginacaoCentroCusto';
import buscarTotalizadoresCentroCusto from '../../actions/centro-custo/buscarTotalizadoresCentroCusto';
import TotalizadoresCentroCusto from './TotalizadoresCentroCusto';
import UploadArquivo from './UploadArquivo';


import Select from 'react-select';
import baixarComprovanteTransferencia from '../../actions/repasse-venda/baixarComprovanteTransferencia';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export class PainelRegistrarCentroCusto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOcorrencia: null,
            nomeComprovante: this.props.centroCustoSelecionado.nomeComprovante || null,
            base64Comprovante: null,
            urlComprovante: this.props.centroCustoSelecionado.urlComprovante || null
        };
        this.handleUploadComprovante = this.handleUploadComprovante.bind(this);
        this.removerComprovante = this.removerComprovante.bind(this);
        this.baixarComprovante = this.baixarComprovante.bind(this)
        this.formRef = React.createRef();

    }

    componentDidMount() {
        this.removerComprovante();
        const {empresaSelecionada} = this.props;
        if (empresaSelecionada && empresaSelecionada.id) {
            this.buscarRegistros();
        }
        this.props.buscarTiposOcorrenciaCentroCusto();
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            this.buscarRegistros();

        }

        const prevId = prevProps.centroCustoSelecionado?.id;
        const currId = this.props.centroCustoSelecionado?.id;
        if (currId && currId !== prevId) {
            this.setState({
                nomeComprovante: this.props.centroCustoSelecionado.nomeComprovante || null,
                urlComprovante: this.props.centroCustoSelecionado.urlComprovante || null,
                base64Comprovante: null // sempre limpa o base64 ao trocar o selecionado
            });
        }
    }


    buscarRegistros() {
        const {empresaSelecionada, filtrosAdicionados} = this.props;
        this.props.buscarCentroCusto(empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, filtrosAdicionados);
        this.props.buscarTotalizadoresCentroCusto(empresaSelecionada.id, this.props.totalRegistros, this.props.filtrosAdicionados);
    }

    selecionarDataOcorrencia(date) {
        if (date) {
            this.setState({dataOcorrencia: date});
        } else {
            this.setState({dataOcorrencia: null});
        }
    }

    montarParametros(values) {
        return {
            id: this.props.centroCustoSelecionado.id,
            empresaId: this.props.empresaSelecionada.id,
            dataOcorrencia: this.state.dataOcorrencia,
            tipoOcorrencia: values.tipoOcorrencia.value,
            tipoEventoOcorrencia: values.tipoEventoOcorrencia.value,
            ocorrencia: values.ocorrencia,
            valorTotalGasto: this.props.valorTotalGasto ? this.props.valorTotalGasto.replace('R$', '') : null,
            nomeComprovante: this.state.nomeComprovante,
            base64Comprovante: this.state.base64Comprovante
        };
    }

    baixarComprovante(){
        baixarComprovanteTransferencia(this.state.urlComprovante, this.state.nomeComprovante).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.state.nomeComprovante);
            document.body.appendChild(link);

            link.click();

        });
    }

    limparCampos() {
        this.selecionarDataOcorrencia(null);
        this.removerSelecionado();
        this.removerComprovante();
        this.props.changeFieldValue('formularioPainelCentroCusto', 'tipoOcorrencia', '');
        this.props.changeFieldValue('formularioPainelCentroCusto', 'tipoEventoOcorrencia', '');
        this.props.changeFieldValue('formularioPainelCentroCusto', 'ocorrencia', '');
        this.props.changeFieldValue('formularioPainelCentroCusto', 'valorTotalGasto', '');
        this.props.changeFieldValue('formularioPainelCentroCusto', 'nomeComprovante', null);
        this.props.changeFieldValue('formularioPainelCentroCusto', 'base64Comprovante', null);
    }

    removerSelecionado() {
        this.props.selecionaCentroCusto()
    }

    excluir() {
        this.props.excluirCentroCusto(this.props.centroCustoSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Centro de custo excluída com sucesso');
                this.buscarRegistros();
            })
    }

    handleUploadComprovante(nome, base64) {
        this.setState({
            nomeComprovante: nome,
            base64Comprovante: base64,
            urlComprovante: null // zera URL porque ainda não foi salvo
        });
    }

    removerComprovante() {
        this.setState({
            nomeComprovante: null,
            base64Comprovante: null,
            urlComprovante: null
        });
    }






    submit(values) {
        const parametros = this.montarParametros(values);

        if (this.props.centroCustoSelecionado.id) {
            this.props.atualizarCentroCusto(parametros)
                .then(() => {
                    this.limparCampos();
                    this.buscarRegistros();
                    this.removerSelecionado();
                });
        } else {
            this.props.cadastrarCentroCusto(parametros)
                .then(() => {
                    this.limparCampos();
                    this.buscarRegistros();
                    this.removerSelecionado();
                });
        }
    }


    renderTabelaCentroCusto() {
        const {listaCentroCusto} = this.props;
        if (!listaCentroCusto || listaCentroCusto.length === 0) {
            return <div className='mt-4'>Nenhum registro de centro de custo encontrado.</div>;
        }

        return (

            <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoCentroCusto}
                                   BotoesPaginacao={BotoesPaginacaoCentroCusto}>
                <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
                    <div className="row cabecalho-desktop">
                        <div className="col-lg-1 col-xl-1"></div>
                        <div className='col'>Data Entrada</div>
                        <div className='col'>Registrado Por</div>
                        <div className='col'>Data Ocorrência</div>
                        <div className='col'>Tipo Ocorrência</div>
                        <div className='col'>Tipo Evento</div>
                        <div className='col'>Valor Total Gasto</div>
                        <div className="col-sm-2 d-flex justify-content-center">Ações</div>
                    </div>
                </div>
                <div className="col-12 conteudo-internas">
                    <div className="lista-table">
                        {listaCentroCusto.map(c => (
                            <CentroCusto
                                key={c.id}
                                centroCusto={c}
                                selecionarDataOcorrencia={this.selecionarDataOcorrencia.bind(this)}
                                scrollToForm={() => {
                                    if (this.formRef?.current) {
                                        this.formRef.current.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}
                            />

                        ))}
                    </div>
                </div>
            </CabecalhoRodapeTabela>

        )
            ;
    }

    exportarCSV(){
        const {empresaSelecionada, filtrosAdicionados} = this.props;
        this.props.buscarCentroCusto(empresaSelecionada.id, 1, this.props.totalRegistros, filtrosAdicionados)
            .then(response => {
                const lista = response.payload.registros || [];
            exportarCentroCustoParaCSV(lista, empresaSelecionada.nome)
        })
    }

    exibirComboPlataforma(event) {
        const {tiposOcorrenciaCentroCusto} = this.props;
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione um tipo...'
                    options={tiposOcorrenciaCentroCusto.map(tipo => ({
                        value: tipo.chave,
                        label: tipo.valor,
                    }))}
                    onChange={value => event.input.onChange(value)}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirComboTipoEventoOcorrecia(event) {
            const tiposEventoOcorrencia = [
                    {chave: 'SAIDA', valor: 'Saída'},
                    {chave: 'ENTRADA', valor: 'Entrada'}];
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione um evento...'
                        options={tiposEventoOcorrencia.map(tipo => ({
                            value: tipo.chave,
                            label: tipo.valor,
                        }))}
                        onChange={value => event.input.onChange(value)}
                        onBlur={() => event.input.onBlur()}
                    />
                    {event.meta.touched
                    && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
                </div>
            )
        }

    render() {

        const {handleSubmit, invalid, submitting} = this.props;
        return (
            <Autorizacao
                perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id), getGestorEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroCaixa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <TotalizadoresCentroCusto  />
                <div className="row internas">
                    <Titulo texto="Painel Centro de Custo" urlRetorno="/home"/>

                    <div className="col-12 filtro-busca">
                        <PainelFiltrosCentroCusto totalizadores={this.props.totalizadores}/>
                    </div>
                    <div className="col-12 filtro-busca mb-3">
                        <div className="dropdown">
                            <button className="btn btn-laranja dropdown-toggle float-right" type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Exportar
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item btn btn-laranja"
                                   onClick={() =>this.exportarCSV()}>Exportar
                                    Lista</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <form ref={this.formRef} onSubmit={handleSubmit(this.submit.bind(this))}>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Registro de Entrada</legend>

                            <div className='form-row col-12 col-sm-9 col-md-9 mt-2'>
                                <label>Data Entrada: </label>
                                <span>{this.props.centroCustoSelecionado.dataEntrada ? <Moment
                                    format="DD/MM/YYYY">{this.props.centroCustoSelecionado.dataEntrada}</Moment> : '-'}</span>
                            </div>

                            <div className='form-row col-12 col-sm-9 col-md-9 mt-2'>
                                <label>Registrado Por: </label>
                                <span>{this.props.centroCustoSelecionado.registradoPor || '-'}</span>
                            </div>

                            <div className='form-row col-12 mt-2'>
                                <div className='col-12 col-sm-4 col-md-4'>
                                    <label className='mt-2'>Data Ocorrência:</label>
                                    <DatePicker
                                        className='form-control ml-2'
                                        value={this.state.dataOcorrencia}
                                        selected={this.state.dataOcorrencia && new Date(this.state.dataOcorrencia)}
                                        onChange={date => this.selecionarDataOcorrencia(date)}
                                        dateFormat="dd/MM/yyyy"
                                        customInput={<InputMask mask="99/99/9999"/>}
                                    />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6">
                                <label>Tipo Ocorrência</label>
                                <Field name='tipoOcorrencia'
                                       validate={[requiredSelect]}
                                       component={this.exibirComboPlataforma.bind(this)}/>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6">
                                <label>Tipo Evento Ocorrência</label>
                                <Field name='tipoEventoOcorrencia'
                                       validate={[requiredSelect]}
                                       component={this.exibirComboTipoEventoOcorrecia.bind(this)}/>
                            </div>
                            <div className='form-row col-12 mt-2'>
                                <div className='col-12 col-sm-4 col-md-5'>
                                    <Field name="valorTotalGasto" component={renderFieldMonetarioLabelEncima}
                                           label='Valor Total Gasto'/>
                                </div>
                            </div>
                            <div className="form-row col-12 mt-2">
                                <div className='col-12 cold-md-12 col-sm-12 campo-ocorrencia'>
                                    <Field name='ocorrencia' component={renderTextArea} label="Ocorrência"
                                           validate={[required]} css="form-control"/>
                                </div>
                            </div>
                            <div className="form-row col-12 mt-3">
                                <UploadArquivo
                                    idEmpresa={this.props.empresaSelecionada.id}
                                    label="Comprovante"
                                    nomeArquivo={this.state.nomeComprovante}
                                    urlArquivo={this.state.urlComprovante}
                                    onChange={this.handleUploadComprovante}
                                    onRemover={this.removerComprovante}
                                    baixarComprovante = {this.baixarComprovante}
                                />



                            </div>


                        </fieldset>
                        <div className='modal-footer'>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.limparCampos()}>
                                Limpar
                            </button>


                            <button type="submit" disabled={invalid || submitting || !this.state.dataOcorrencia}
                                    className="btn btn-laranja">Salvar
                            </button>
                        </div>
                    </form>

                </div>
                <div className="lista-table">
                    {this.renderTabelaCentroCusto()}
                </div>
                <ModalExcluirCentroCusto centroCustoSelecionado={this.props.centroCustoSelecionado}
                                         excluir={this.excluir.bind(this)}
                                         limparSelecaoCentroCusto={this.removerSelecionado.bind(this)}/>
            </Autorizacao>
        );
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
    centroCustoSelecionado: state.centroCusto.centroCustoSelecionado,
    listaCentroCusto: state.centroCusto.listaCentroCusto,
    totalRegistros: state.centroCusto.totalCentroCusto,
    totalizadores: state.centroCusto.totalizadores || {},
    filtrosAdicionados: state.filtrosAdicionadosCentroCusto,
    paginaAtual: state.paginaAtualCentroCusto,
    registrosPorPagina: state.registrosPorPaginaCentroCusto,
    valorTotalGasto: formValueSelector('formularioPainelCentroCusto')(state, 'valorTotalGasto'),
    nomeComprovante: formValueSelector('formularioPainelCentroCusto')(state, 'nomeComprovante'),
    base64Comprovante: formValueSelector('formularioPainelCentroCusto')(state, 'base64Comprovante'),

    tiposOcorrenciaCentroCusto: state.centroCusto.tiposCentroCusto || [],

});

export const mapDispatchToProps = dispatch => bindActionCreators({
    changeFieldValue,
    cadastrarCentroCusto,
    atualizarCentroCusto,
    excluirCentroCusto,
    buscarCentroCusto,
    buscarTiposOcorrenciaCentroCusto,
    selecionaCentroCusto,
    buscarTotalizadoresCentroCusto,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioPainelCentroCusto',
})(PainelRegistrarCentroCusto));
